/** @format */
import { Injectable } from '@angular/core';
import { StudyTerm, LocalDateRange } from 'common-typescript/types';
import moment from 'moment';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { TimelineStudyYearsService } from './timeline-study-years.service';

@Injectable()
export class CurrentAndUpcomingStudyTermsService {
    /**
     * Emits only current or upcoming study terms and periods
     * that are visible on the timeline (i.e., periods of {@link TimelineStudyYearsService.studyYears$})
     * If there is no {@link SelectedValidatablePlanService.selectedValidatablePlan$}, an empty array is returned.
     */
    readonly studyTerms$: Observable<readonly StudyTerm[]>;

    constructor(timelineStudyYearsService: TimelineStudyYearsService) {
        this.studyTerms$ = timelineStudyYearsService.studyYears$.pipe(
            map(studyYears =>
                studyYears.flatMap(studyYear =>
                    studyYear.studyTerms
                        .filter(studyTerm => CurrentAndUpcomingStudyTermsService.isCurrentOrUpcoming(studyTerm.valid))
                        .map(studyTerm => ({
                            ...studyTerm,
                            studyPeriods: studyTerm.studyPeriods.filter(studyPeriod =>
                                CurrentAndUpcomingStudyTermsService.isCurrentOrUpcoming(studyPeriod.valid),
                            ),
                        })),
                ),
            ),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
    }

    static isCurrentOrUpcoming(valid: LocalDateRange): boolean {
        return valid && (valid?.endDate == null || moment().isBefore(valid.endDate, 'day'));
    }
}
